import {
  ChangeEvent,
} from 'react';

type AutoExpandTextareaProps = {
  value: string;
  minRows: number;
  maxRows: number;
  className: string;
  handlePromptChange: (e: ChangeEvent<HTMLTextAreaElement>) => void;
  handlePromptSend: (e: React.KeyboardEvent<HTMLTextAreaElement>) => void;
  placeholder: string;
  maxLength: number;
  id: string;
}

const AutoExpandTextarea = (props: AutoExpandTextareaProps): JSX.Element => {

  const {
    value,
    minRows,
    maxRows,
    className,
    handlePromptChange,
    handlePromptSend,
    placeholder,
    maxLength,
    id,
  } = props;

  // Calculate number of rows based on content
  const calculateRows = (): number => {
    const textarea = document.getElementById(id) as HTMLTextAreaElement;
    if (!textarea) {
      return minRows;
    }

    // Get line height in pixels to use for calculation
    const computedStyle = window.getComputedStyle(textarea);
    const {
      lineHeight,
      fontSize
    } = computedStyle;

    const lineHeightNum = lineHeight
      ? parseInt(lineHeight, 10)
      : parseInt(fontSize, 10) * 1.2;

    // Reset to minRows to get accurate measurement
    textarea.rows = minRows;

    // Calculate number of rows needed for the content
    const textareaRows = Math.floor(textarea.scrollHeight / lineHeightNum);
    const rows = Math.min(Math.max(textareaRows, minRows), maxRows);
    textarea.rows = rows;
    return rows;
  };

  const rows = calculateRows();

  return (
    <textarea
      className={className}
      id={id}
      onKeyPress={handlePromptSend}
      maxLength={maxLength}
      value={value}
      onChange={handlePromptChange}
      placeholder={placeholder}
      rows={rows}
      style={{
        resize: 'none', // Disable manual resizing
        overflow: rows >= maxRows ? 'auto' : 'hidden', // Show scrollbar only when reaching maxRows
      }}
    />
  );
};

export default AutoExpandTextarea;
